import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "./firebase";

export function doSignInWithEmailAndPassword(email, passowrd) {
  return signInWithEmailAndPassword(auth, email, passowrd);
}

export function doSignOut() {
  return signOut(auth);
}

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
};

export const doCreateUserWithEmailAndPassword = (email, passowrd) => {
  return createUserWithEmailAndPassword(auth, email, passowrd);
};

export const forgetPasswordSendEmail = (email) => {
  return sendPasswordResetEmail(auth, email);
};
